import { render, staticRenderFns } from "./PaymentBody.vue?vue&type=template&id=54f8b398&scoped=true&"
import script from "./PaymentBody.vue?vue&type=script&lang=js&"
export * from "./PaymentBody.vue?vue&type=script&lang=js&"
import style0 from "./PaymentBody.vue?vue&type=style&index=0&id=54f8b398&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54f8b398",
  null
  
)

export default component.exports